<template>
</template>
<script>
  export default {
    mounted () {
      this.$store.dispatch('authentication/refresh')
    }
  }
</script>
